@if (toastModel.visible) {
  <div class="toast">
    @if (toastModel.type) {
      <div class="toast" [class]="toastModel.cssClass" aria-live="assertive" aria-atomic="true" animation="true" #toastContainer>
        @if (toastModel.title && toastModel.title.length > 0) {
          <div class="toast-header">
            {{ toastModel.title }}
            <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close" (click)="close()"></button>
          </div>
        }
        <div class="toast-body">
          {{ toastModel.message }}
        </div>
      </div>
    }
  </div>
}